import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBufferComponent } from './simple-icons-buffer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBufferComponent ],
    exports:      [ SimpleIconsBufferComponent ],
    bootstrap:    []
})
export class SimpleIconsBufferModule {}
